/**
 * How far the world's load really is, for the loading bar (owner 13 Oct: back to a progress bar; Sol owner-r25 Q2:
 * "connect it to real loading progress and never hold artificially at 99%"). Unity's scene page reports its own
 * download/start progress (route 'p', value 0-1): that fills the bar to 80%; the scene finishing (route 'x') takes it to
 * 90%; the avatar being ready ends the load (the bar completes and says Ready!). A new load starts again from 0.
 */
export const UNITY_SHARE = 80;
export const SCENE_DONE = 90;

let value = 0;
const listeners = new Set();
const tell = () => listeners.forEach(listener => listener(value));

/** A milestone in percent; the bar never goes backwards within one load. */
export function setLoadProgress(percent) {
  const next = Math.max(0, Math.min(100, Number(percent) || 0));
  if (next <= value) return;
  value = next;
  tell();
}

/** Unity's own loader progress (0-1) as its share of the bar. */
export const setUnityLoadProgress = fraction => setLoadProgress(Math.max(0, Math.min(1, Number(fraction) || 0)) * UNITY_SHARE);

export function resetLoadProgress() {
  value = 0;
  tell();
}

export const loadProgress = () => value;

export function onLoadProgress(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
